export default function searchPage(iPage: number, setCurrentPage: any, history: any) {
  setCurrentPage(iPage);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const queryFromUrl = urlSearchParams.get("query");
  const categoryFromUrl = urlSearchParams.get("category");
  const subCategoryFromUrl = urlSearchParams.get("subCategory");
  const citiesFromUrl = urlSearchParams.get("cities");
  const adTypesFromUrl = urlSearchParams.get("adTypes");
  // const currentPageFromUrl = urlSearchParams.get("page");

  const qq = queryFromUrl ? `query=${queryFromUrl}&` : "";
  const ct = categoryFromUrl ? `category=${categoryFromUrl}&` : "";
  const sc = subCategoryFromUrl ? `subCategory=${subCategoryFromUrl}&` : "";
  const cc = citiesFromUrl ? `cities=${citiesFromUrl}&` : "";
  const at = adTypesFromUrl ? `adTypes=${adTypesFromUrl}&` : "";
  const pg = `page=${iPage}`;

  history.push(`/ads/home?${qq}${ct}${sc}${cc}${at}${pg}`);
}
